import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import 'chosen-js/chosen.css';
import chosen from 'chosen-js/chosen.jquery';
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');

class EpiMonitoring extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompate = this.dateCompare.bind(this);
		this.checking = this.checking.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],
			change_check: false,
			start_date 	: "",
			end_date 	: "",
            sex:"all",
            donor_age:"all",
            option:"all",
            test_ids:["all"],
            tests:[],
            listado:[],
            totales:{},

			//test datatable to export
			columns:[
				{title:'Donador'},
                {title:'Edad'},
                {title:'Género'},
				{title:'Tel'},
				{title:'Correo'},
				{title:'Localizado'},
                {title:'Segunda Muestra'},
                {title:'Expediente Cerrado'}
			],
			filename:"Seguimiento Epidemiológico",
		
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		this.$select = $(this.select);
		this.$select.chosen();
		this.$select.on('change', this.handleChange);

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});
		
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
        })
        
        fetch(Config.default.apiGateway.URL+'analitical_test?option=active',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
            if(response !== undefined){
                var list = [];
                response.map((res)=>
                    list.push({
                        id: res.analitical_test.id,
                        name: res.analitical_test.name
                    })
                );

                this.setState({tests: list});
                this.$select.trigger("chosen:updated");
            }
		})

		this.setTable();
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}
	
	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		//this.$select.trigger("chosen:updated");
		
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY")
		this.$el = $(this.el);
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
					
                        doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
                        

                        doc.content.push(
                            {text: "Procesados con segunda muestra: "+this.state.totales.has_second_sample},
                            {text: "No localizados: "+this.state.totales.not_located},
                            {text: "Localizados: "+this.state.totales.located},
                            {text: "Expedientes cerrados: "+this.state.totales.closed},
                        )
						
                        doc.defaultStyle.fontSize = 6.5;
                        doc.styles.tableHeader.fontSize = 6.5;    
                        doc.content[3].table.widths = ["30%", "5%", "10%", "10%", "15%", "10%", "10%", "10%",]
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
		});
		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target.name === 'test_ids'){
			var options = e.target.options;
			var value = [];
			var name = "";
			for (var i = 0, l = options.length; i < l; i++) {
			    if (options[i].selected) {
                    if(options[i].value === 'all'){
			    		value = [];
			    		value.push(options[i].value);
			    		break;
			    		
			    	}else{
			    		value.push(parseInt(options[i].value));
			    		name += options[i].text + ', '
			    	}
			    }
			}

			this.setState({
				[e.target.name]: value,
				lab_section_name:name.substring(0,name.length-2)
			});

			this.$select.val(value).trigger("chosen:updated");
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}


		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompate()){
				this.props.waiting.handleShow('Buscando...');

                var test = [];
				if(this.state.test_ids[0] === 'all'){
					this.state.tests.map((l)=>{
						return test.push(l.id);
					});
				}else{
					test = this.state.test_ids;
				}

				var obj = {
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					sex: this.state.sex,
					donor_age: this.state.donor_age,
                    option: this.state.option,
                    test_ids:test,
					health_facilities_id:this.state.health_facilities_id
				}
				
				fetch(Config.default.apiGateway.URL+'reports/epi_monitoring_report',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var list = [];

                        response.resp.map((res)=>{
                            var obj = [
                                res.donor_name,
                                res.donor_age,
                                res.sex
                            ];

                            var tels = "";
                            res.phones.map((p, i)=>{
                                tels += p.number+(res.phones.length - 1 === i ? "" : ", ");
                            });

                            obj.push(tels, res.email, res.call_status,res.has_second_sample, res.closed);

                            list.push(obj);

                        })

						this.setState({listado:list, totales: response.totals});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Laboratorio ->
					{this.state.filename}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_laboratory"} 
		            submenu={"help_epi_monitoring_report"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
                                <div className="form-group">
                                    <span className="span-min">Fecha Desde</span>
                                    <input type="date" className="form-control hour-input" name="start_date" id="start_date"
                                        value={this.state.start_date} onChange={this.handleChange} required  />
                                </div>
                                <div className="form-group">
                                    <span className="span-min">Fecha Hasta</span>
                                    <input type="date" className="form-control hour-input" name="end_date" id="end_date"
                                        value={this.state.end_date} onChange={this.handleChange} required />
                                </div>
							
									
								<div className="form-group">
									<span className="span-min">Género</span>
									<select className="form-control" name="sex" id="sex"
										value={this.state.sex} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="HOMBRE">HOMBRE</option>
                                        <option value="MUJER">MUJER</option>
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Edad</span>
									<select className="form-control"  name="donor_age" id="donor_age"
										value={this.state.donor_age} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
                                        <option value="18-24">18-24</option>
                                        <option value="25-44">24-44</option>
                                        <option value="45-65">45-65</option>
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Estatus</span>
									<select className="form-control"  name="option" id="option"
										value={this.state.option} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
                                        <option value="all">TODOS</option>
										<option value="CONECTADO">CONECTADO</option>
										<option value="NO CONECTADO">NO CONECTADO</option>
                                        <option value="CERRADO">CERRADO</option>
									</select>
								</div>
								<div className="form-group">
									<span className="span-min col-xs-12" style={{width:'100%'}}>Pruebas</span>
									<select className="form-control"  name="test_ids" id="test_ids"
										value={this.state.test_ids} onChange={(e)=>this.handleChange}
										required multiple={true} data-placeholder={'Seleccione...'}
										ref={el => this.select = el}>
                                        <option value="all">TODOS</option>
										{this.state.tests.map((l, i)=>
											<option key={i} value={l.id}>
												{l.name}
											</option>
										)}
									</select>
									
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
								</div>
								{this.state.search_type === 'date' ?
									<div className="col-xs-12" >
										<span>
											Información Del:   {this.state.start_date !== "" ? 
												moment(this.state.start_date).format('DD/MM/YYYY')
											:'  '}
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ? 
												moment(this.state.end_date).format('DD/MM/YYYY')
											:'  '}
										</span>
									</div>
								: null}

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table table-striped"} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>

								</div>
                                <div className="col-xs-12 form-group">
                                    {console.log(this.state.totales)}
                                    {this.state.totales.closed !== undefined &&
                                        <div className="col-xs-12">
                                            <div>
                                                <label>Procesados con segunda muestra:</label> <span>{this.state.totales.has_second_sample}</span>
                                            </div>
                                            <div>
                                                <label>No localizados:</label> <span>{this.state.totales.not_located}</span>
                                            </div>
                                            <div>
                                                <label>Localizados:</label> <span>{this.state.totales.located}</span>
                                            </div>
                                            <div>
                                                <label>Expedientes cerrados:</label> <span>{this.state.totales.closed}</span>
                                            </div>
                                        </div>
                                    }
                                </div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (EpiMonitoring);